import React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import {
	Box,
	Button,
	Flex,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
} from '@chakra-ui/react'
import { TbChevronDown } from 'react-icons/tb'

const NavbarLinks = ({ links }) => {
	const { asPath } = useRouter()

	function isSlugActive(slug) {
		return asPath === slug
	}

	function getActiveTitle() {
		const link = links.find(link => isSlugActive(link.slug))
		return link?.title
	}

	return (
		<>
			{/* Desktop navigation */}
			<Flex display={{ base: 'none', md: 'flex' }} w='full' gap={1} me='auto'>
				{links.map((item: any) => {
					const isActive = isSlugActive(item.slug)
					return (
						<Button
							cursor='pointer'
							key={item.title}
							variant='ghost'
							as={Link}
							href={item.slug}
							colorScheme={isActive ? 'gray' : 'primary'}
							pointerEvents={isActive ? 'none' : 'auto'}
						>
							{item.title}
						</Button>
					)
				})}
			</Flex>
			{/* Mobile naviation */}
			<Box display={{ base: 'flex', md: 'none' }} w='full'>
				<Menu>
					<MenuButton
						as={Button}
						aria-label='Menu'
						rightIcon={<TbChevronDown />}
						size='sm'
						variant='ghost'
						me='auto'
						iconSpacing={1}
					>
						{getActiveTitle()}
					</MenuButton>
					<MenuList>
						{links.map((item: any) => (
							<MenuItem
								key={item.slug}
								as={Link}
								href={item.slug}
								isDisabled={isSlugActive(item.slug)}
							>
								{item.title}
							</MenuItem>
						))}
					</MenuList>
				</Menu>
			</Box>
		</>
	)
}

export default NavbarLinks
